import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Input, Picker, Span, Button, Row } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

import { IForm } from '../../types'

interface IFilterContracts {
  handleSearch: (_form: IForm) => void
}

export const FilterContracts: React.FC<IFilterContracts> = ({
  handleSearch,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useFormContext<IForm>()

  const handleResetForm = () => {
    reset()
    handleSearch(watch())
  }

  return (
    <>
      <Row alignItems="flex-start">
        <Input
          maxLength={300}
          label="Contrato"
          placeholder="Nº"
          control={control}
          errors={errors}
          formValue="CdContrato"
        />
        <Input
          control={control}
          errors={errors}
          label="CPF/CNPJ/Cód.Fornecedor"
          placeholder="Nº"
          formValue="CdDocto"
          maxLength={18}
          customMask={(cdDocto) => cdDocto && cdDocto.length > 9
            ? ['###.###.###-##', '##.###.###/####-##']
            : ['############']
          }
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Input
          control={control}
          errors={errors}
          maxLength={300}
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="NmFornecedor"
        />
        <Input
          control={control}
          errors={errors}
          maxLength={300}
          label="Contraparte"
          placeholder="Nome do Contraparte"
          formValue="NmContraparte"
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Picker
          control={control}
          errors={errors}
          label="Data Cadastro"
          id='pickerDtIni Cad'
          defaultValue={null}
          formValue="DtInicioSap"
          maxDate={getValues('DtFimSap') || null}
        />
        <Span
          text="à"
          marginTop={SPACING.spacing30}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Picker
          control={control}
          errors={errors}
          defaultValue={''}
          id='pickerDtFimCad'
          formValue="DtFimSap"
          minDate={getValues('DtInicioSap') || null}
          label=""
        />
      </Row>
      <Row
        alignItems="center"
        justifyContent="flex-end"
        marginTop={SPACING.spacing15}
      >
        <Button
          text="Limpar"
          onClick={handleResetForm}
          variantButton="text"
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Button
          text="Pesquisar"
          endIcon={<MagnifyingGlassIcon />}
          onClick={handleSubmit(handleSearch)}
          key={'searchFormFilterContract'}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
      </Row>
    </>
  )
}
